import React, {Component} from 'react';
import bg from '../../assets/image/rwmbg_cmslogin.jpg';

class Background extends Component {
	componentWillMount() {
    var appStyle = document.getElementById('app-body').style;
    var bodyStyle = document.body.style;

    appStyle.height = '100%';
    bodyStyle.height = '100%';
    bodyStyle.backgroundImage = 'url("' + bg + '")';
    bodyStyle.backgroundSize = '100% 100%';
    bodyStyle.backgroundRepeat = 'no-repeat';

  }

	// REMOVE BACKGROUND WHEN UNMOUNTING
  // componentWillUnmount() {
	// 	var appStyle = document.getElementById('app-body').style;
  //   var bodyStyle = document.body.style;
	//
  //   appStyle.height = null;
  //   bodyStyle.height = null;
  //   bodyStyle.backgroundImage = null;
  //   bodyStyle.backgroundSize = null;
  //   bodyStyle.backgroundRepeat = null;
  // }

	render() {
		return (
			<div>
        {this.props.children}
			</div>
		);
	}
}

export default Background;



// WEBPACK FOOTER //
// ./components/Login/Background.js